/**
 * Funktioner til tekstbehandling
 */

/**
 * Saniterer tekst for ugyldige Unicode-tegn for at undgå problemer ved API-kald
 * 
 * @param {string} text - Input tekst der skal saniteres
 * @returns {string} - Saniteret tekst uden ugyldige tegn
 */
export function sanitizeText(text) {
  if (!text) return '';
  
  return text
    // Fjern high surrogates uden low surrogates
    .replace(/[\uD800-\uDBFF](?![\uDC00-\uDFFF])/g, '')
    // Fjern low surrogates uden high surrogates
    .replace(/(?<![\uD800-\uDBFF])[\uDC00-\uDFFF]/g, '')
    // Fjern andre problematiske kontroltegn
    .replace(/[\u0000-\u001F\u007F-\u009F]/g, '');
}

/**
 * Tæller antal emojis i en tekst
 * 
 * @param {string} text - Input tekst
 * @returns {number} - Antal emojis i teksten
 */
export function countEmojis(text) {
  if (!text) return 0;
  
  // Regex der fanger de fleste moderne emojis inklusiv kombinations-emojis
  const emojiRegex = /[\p{Emoji_Presentation}\p{Extended_Pictographic}]/gu;
  const matches = text.match(emojiRegex);
  
  return matches ? matches.length : 0;
}

/**
 * Tæller antal ord i en tekst
 * 
 * @param {string} text - Input tekst
 * @returns {number} - Antal ord i teksten
 */
export function countWords(text) {
  if (!text) return 0;
  
  // Fjern først alle emojis og andre ikke-tekstlige elementer
  const cleanText = text
    .replace(/[\p{Emoji_Presentation}\p{Extended_Pictographic}]/gu, '')
    .trim();
  
  // Del teksten ved whitespace og tæl ikke-tomme dele
  const words = cleanText.split(/\s+/).filter(word => word.length > 0);
  
  return words.length;
}

/**
 * Beregner emoji-tæthed (emojis pr. 100 ord) i en tekst
 * 
 * @param {string} text - Input tekst
 * @returns {number} - Emoji-tæthed (emojis pr. 100 ord)
 */
export function getEmojiDensity(text) {
  if (!text) return 0;
  
  const emojiCount = countEmojis(text);
  const wordCount = countWords(text);
  
  if (wordCount === 0) return 0;
  
  // Beregn emojis pr. 100 ord
  return (emojiCount / wordCount) * 100;
}

export default {
  sanitizeText,
  countEmojis,
  countWords,
  getEmojiDensity
}; 